import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Station } from '../../design';
import './journey.css';
export const JOURNEY = [
    {
        k: '探',
        title: 'Find',
        text: 'A hunt searches the auctions through your own exporter accounts on a schedule, as often as every 3 hours. It reads each auction sheet and emails you when a match turns up.'
    },
    {
        k: '札',
        title: 'Bid',
        text: 'You get a bid range from sold lots of the same generation and grade. The bid goes through your exporter, and the app writes the email for you to see before it goes.'
    },
    {
        k: '関',
        title: 'Customs',
        text: 'A licensed broker clears the car. Kappa Customs is built in, or you can bring your own. Either way the app prepares the ISF and drafts every email to them.'
    },
    {
        k: '運',
        title: 'Ship',
        text: 'Once it’s released at the port it needs a truck. Email your dispatcher, or line up quotes from uShip and Super Dispatch side by side.'
    },
    {
        k: '原',
        title: 'Landed cost',
        text: 'Drop in the invoices and receipts. The app reads each cost line off its document for you to check, then adds them up per car.'
    }
];
/** The five stops in a row (a column on a phone), each with its station mark. */ export function Journey({ stops = JOURNEY, testid, headingLevel = 3 }) {
    const H = headingLevel === 3 ? 'h3' : 'h4';
    return /*#__PURE__*/ _jsx("ol", {
        className: "mk-journey",
        "data-testid": testid,
        children: stops.map((s, i)=>/*#__PURE__*/ _jsxs("li", {
                className: "mk-journey__stop",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "mk-journey__mark",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsx(Station, {
                            k: s.k,
                            done: i === stops.length - 1
                        })
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        className: "mk-journey__n",
                        children: [
                            "0",
                            i + 1
                        ]
                    }),
                    /*#__PURE__*/ _jsx(H, {
                        className: "mk-journey__title",
                        children: s.title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mk-journey__text",
                        children: s.text
                    })
                ]
            }, s.k))
    });
}
